const streamsList = ["Business", "Tech", "Design"];

const streams = streamsList.map((v) => ({
  label: v,
  value: v,
}));
export default streams;
